import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../Icon';
import './InputLabelWrapper.css'

const baseLabelClassName = 'flex flex-col flex-1 text-white text-xs pl-1 select-none';
const spanClassName = 'flex flex-row items-center cursor-pointer focus:outline-none text-sm sm:text-lg';
const sortIconMap = {
  descending: 'sorting-active-up',
  ascending: 'sorting-active-down',
  none: 'sorting',
};

const InputLabelWrapper = ({
  label,
  isSortable,
  sortDirection,
  onLabelClick,
  className,
  children,
  headerExtra,
}) => {
  const onClickHandler = e => {
    if (!isSortable) {
      return;
    }

    onLabelClick(e);
  };

  return (
    <div className={classnames(baseLabelClassName, className)}>
      <div className="flex flex-row items-center justify-between mr-2">
        <span
          role="button"
          className={spanClassName}
          onClick={onClickHandler}
          onKeyDown={onClickHandler}
          tabIndex="0"
        >
          {label}
          {isSortable && (
            <Icon
              name={sortIconMap[sortDirection]}
              className={classnames(
                'mx-2 w-2',
                sortDirection !== 'none' ? 'text-primary-light' : 'text-primary-main'
              )}
            />
          )}
        </span>
        {headerExtra}
      </div>
      <span>{children}</span>
    </div>
  );
};

InputLabelWrapper.defaultProps = {
  className: '',
  headerExtra: null,
};

InputLabelWrapper.propTypes = {
  label: PropTypes.node.isRequired,
  isSortable: PropTypes.bool.isRequired,
  sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']).isRequired,
  onLabelClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  headerExtra: PropTypes.node,
};

export default InputLabelWrapper;
